import Vue from "vue";
import Vuex from "vuex";

// import createPersistedState from "vuex-persistedstate";
// import localForage from "localforage";

import appsettings from "./modules/appSettings.js";
import cashmanagement from "./modules/cashmanagement.js";
import cashposition from "./modules/cashposition.js";
import payments from "./modules/payments";
import activity from "./modules/activity.js";
import auth from "./modules/auth.js";
import localdb from "./modules/localdb.js";

Vue.use(Vuex);

// const vuexStorage = createPersistedState({
//   key: "appState",
//   storage: window.localStorage,
// });

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  // plugins: [vuexStorage],
  modules: {
    appsettings,
    cashmanagement,
    cashposition,
    payments,
    auth,
    localdb,
    activity,
  },
});
